import { Translation } from './type'

const ja: Translation = {
  auth: {
    login: 'ログイン',
    signup: 'サインアップ'
  },
  messages: {
    success: '成功'
  },
  errors: {
    system_error:
      'システムエラーが発生しました<br>しばらく経ってから再度お試しください<br>それでも解決しない場合は管理者にお尋ねください',
    upload_file_max_size: '画像は容量{size}まででご準備ください'
  }
}

export default ja
